export default function getMetaContent(name: string): string | undefined {
  const meta = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);

  return meta?.content;
}
